import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getHourSlots } from '../../Constant.js'
import axios from 'axios'
import Toggle from 'react-toggle'
import Select from 'react-select'
class DestinationAdd extends React.Component {
  state = {
    destination_address_en: '',
    destination_address_ar: '',
    destination_long: '',
    destination_lat: '',
    destination_min_hour: '',

    price: '',
    price_before_markup: '',
    monday_price: '',
    tuesday_price: '',
    wednesday_price: '',
    thursday_price: '',
    friday_price: '',
    saturday_price: '',

    monday_price_before_markup: '',
    tuesday_price_before_markup: '',
    wednesday_price_before_markup: '',
    thursday_price_before_markup: '',
    friday_price_before_markup: '',
    saturday_price_before_markup: '',

    b2b_price: '',
    b2b_monday_price: '',
    b2b_tuesday_price: '',
    b2b_wednesday_price: '',
    b2b_thursday_price: '',
    b2b_friday_price: '',
    b2b_saturday_price: '',

    is_flash_offer: false,
    enable_b2b_prices: false,

    book_by: 'hours',
    min_days: null,
    max_days: null,

    isData: false,
    same_price: false,

    holiday_prices: [],
    startingDate: new Date().toISOString().slice(0, 10),

    cruise_destination_prices: [],

    check_in_time: '',
    check_out_time: '',
  }

  componentDidMount() {
    this.getAddress()
    this.dashbord()
  }

  addDurationPrices = () => {
    this.setState({
      cruise_destination_prices: [
        ...this.state.cruise_destination_prices,
        {
          from_date: '',
          to_date: '',
          sunday_price: null,
          monday_price: null,
          tuesday_price: null,
          wednesday_price: null,
          thursday_price: null,
          friday_price: null,
          saturday_price: null,
          b2b_sunday_price: null,
          b2b_monday_price: null,
          b2b_tuesday_price: null,
          b2b_wednesday_price: null,
          b2b_thursday_price: null,
          b2b_friday_price: null,
          b2b_saturday_price: null,
        },
      ],
    })
  }

  removeDurationPrice = (index) => {
    let list = [...this.state.cruise_destination_prices]
    list.splice(index, 1)
    this.setState({ cruise_destination_prices: list })
  }

  handleChangeDurationPrice = (index, event) => {
    let list = [...this.state.cruise_destination_prices]
    if (event.target.name === 'from_date') {
      list[index][event.target.name] = event.target.value
      list[index]['to_date'] = ''
    } else {
      list[index][event.target.name] = event.target.value
    }
    this.setState({ cruise_destination_prices: list })
  }

  handleChange = (event) => {
    const { name, checked, value } = event.target
    if (name === 'enable_b2b_prices') {
      this.setState({ enable_b2b_prices: checked }, () => {
        // If disabling B2B, sync B2B prices to normal prices
        if (!checked) {
          this.syncB2BPricesToNormal()
        }
      })
    } else if (name === 'is_flash_offer') {
      this.setState({ is_flash_offer: checked })
    } else if (name === 'same_price') {
      this.setState({ same_price: checked }, () => {
        if (checked) {
          this.syncAllPrices()
        }
      })
    } else {
      this.setState({ [name]: value }, () => {
        // If price, b2b_price or price_before_markup changes and same_price is on, sync prices
        if (this.state.same_price && (name === 'price' || name === 'b2b_price' || name === 'price_before_markup')) {
          this.syncAllPrices()
        }
        // If B2B is disabled and normal price fields change, sync B2B fields
        if (
          !this.state.enable_b2b_prices &&
          (name === 'price' ||
            name === 'monday_price' ||
            name === 'tuesday_price' ||
            name === 'wednesday_price' ||
            name === 'thursday_price' ||
            name === 'friday_price' ||
            name === 'saturday_price')
        ) {
          this.syncB2BPricesToNormal()
        }
      })
    }
  }

  // Helper to sync all main and duration prices when same_price is enabled
  syncAllPrices = () => {
    // Main state fields
    const price = this.state.price
    const b2b_price = this.state.b2b_price
    const price_before_markup = this.state.price_before_markup
    const enable_b2b_prices = this.state.enable_b2b_prices

    // Update main day fields
    const dayFields = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    let newState = {}
    dayFields.forEach((day) => {
      newState[`${day}_price`] = price
      newState[`b2b_${day}_price`] = enable_b2b_prices ? b2b_price : price
      newState[`${day}_price_before_markup`] = price_before_markup
    })

    // Also update duration prices
    let updatedDurations = this.state.cruise_destination_prices.map((item) => {
      let newItem = { ...item }
      // Normal prices
      newItem['sunday_price'] = price
      dayFields.forEach((day) => {
        newItem[`${day}_price`] = price
      })
      // B2B prices
      if (enable_b2b_prices) {
        newItem['b2b_sunday_price'] = b2b_price
        dayFields.forEach((day) => {
          newItem[`b2b_${day}_price`] = b2b_price
        })
      } else {
        newItem['b2b_sunday_price'] = price
        dayFields.forEach((day) => {
          newItem[`b2b_${day}_price`] = price
        })
      }
      return newItem
    })
    this.setState({ ...newState, cruise_destination_prices: updatedDurations })
  }

  // Helper to sync B2B prices to normal prices (for both main and duration)
  syncB2BPricesToNormal = () => {
    const dayFields = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    let newState = {
      b2b_price: this.state.price,
    }
    dayFields.forEach((day) => {
      newState[`b2b_${day}_price`] = this.state[`${day}_price`]
    })
    // For duration prices
    let updatedDurations = this.state.cruise_destination_prices.map((item) => {
      let newItem = { ...item }
      newItem['b2b_sunday_price'] = item['sunday_price']
      dayFields.forEach((day) => {
        newItem[`b2b_${day}_price`] = item[`${day}_price`]
      })
      return newItem
    })
    this.setState({ ...newState, cruise_destination_prices: updatedDurations })
  }

  dashbord = async () => {
    var cruiseId = this.props.boatId

    await axios
      .get(Constant.getAPI() + `/cruise/list-cruise-destinations/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id === this.props.destination_Id)

          if (matchItem?.length) {
            const itm = matchItem[0]

            this.setState({
              ...itm,
              desti_id: {
                value: itm?.desti_id,
                label: `${itm?.destination_address_en}/${itm?.destination_address_ar}`,
              },
            })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getAddress = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/list-destinations`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ GetAddress: res.data.data })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addDestination = () => {
    this.setState({ isSaving: true })
    var cruiseId = this.props.boatId
    var destination_address_id = this.state.GetAddress?.filter((item) => item.id === this.state.desti_id?.value)

    var data = {
      cruise_id: cruiseId,
      destination_address_en: destination_address_id?.[0]?.destination_address_en,
      destination_address_ar: destination_address_id?.[0]?.destination_address_ar,
      destination_long: destination_address_id?.[0]?.destination_long,
      destination_lat: destination_address_id?.[0]?.destination_lat,

      desti_id: destination_address_id?.[0]?.id,
      holiday_prices: this.state.holiday_prices,

      is_flash_offer: this.state.is_flash_offer,
      enable_b2b_prices: this.state.enable_b2b_prices,

      book_by: this.state.book_by,

      price_before_markup: this.state.price_before_markup,
      monday_price_before_markup: this.state.monday_price_before_markup,
      tuesday_price_before_markup: this.state.tuesday_price_before_markup,
      wednesday_price_before_markup: this.state.wednesday_price_before_markup,
      thursday_price_before_markup: this.state.thursday_price_before_markup,
      friday_price_before_markup: this.state.friday_price_before_markup,
      saturday_price_before_markup: this.state.saturday_price_before_markup,

      price: this.state.price,
      monday_price: this.state.monday_price,
      tuesday_price: this.state.tuesday_price,
      wednesday_price: this.state.wednesday_price,
      thursday_price: this.state.thursday_price,
      friday_price: this.state.friday_price,
      saturday_price: this.state.saturday_price,

      b2b_price: this.state.b2b_price,
      b2b_monday_price: this.state.b2b_monday_price,
      b2b_tuesday_price: this.state.b2b_tuesday_price,
      b2b_wednesday_price: this.state.b2b_wednesday_price,
      b2b_thursday_price: this.state.b2b_thursday_price,
      b2b_friday_price: this.state.b2b_friday_price,
      b2b_saturday_price: this.state.b2b_saturday_price,

      ...(this.state.book_by === 'day' && {
        min_days: this.state.min_days,
        max_days: this.state.max_days,
        check_in_time: this.state.check_in_time,
        check_out_time: this.state.check_out_time,
        cruise_destination_prices: this.state.cruise_destination_prices,

        price: this.state?.cruise_destination_prices?.[0]?.sunday_price,
        monday_price: this.state?.cruise_destination_prices?.[0]?.monday_price,
        tuesday_price: this.state?.cruise_destination_prices?.[0]?.tuesday_price,
        wednesday_price: this.state?.cruise_destination_prices?.[0]?.wednesday_price,
        thursday_price: this.state?.cruise_destination_prices?.[0]?.thursday_price,
        friday_price: this.state?.cruise_destination_prices?.[0]?.friday_price,
        saturday_price: this.state?.cruise_destination_prices?.[0]?.saturday_price,

        b2b_price: this.state?.cruise_destination_prices?.[0]?.b2b_sunday_price,
        b2b_monday_price: this.state?.cruise_destination_prices?.[0]?.b2b_monday_price,
        b2b_tuesday_price: this.state?.cruise_destination_prices?.[0]?.b2b_tuesday_price,
        b2b_wednesday_price: this.state?.cruise_destination_prices?.[0]?.b2b_wednesday_price,
        b2b_thursday_price: this.state?.cruise_destination_prices?.[0]?.b2b_thursday_price,
        b2b_friday_price: this.state?.cruise_destination_prices?.[0]?.b2b_friday_price,
        b2b_saturday_price: this.state?.cruise_destination_prices?.[0]?.b2b_saturday_price,
      }),
      ...(this.state.book_by === 'hours' && {
        destination_min_hour: this.state.destination_min_hour,
      }),
    }

    console.log(data)
    if (this.props.destination_Id) {
      this.setState({ isData: true })
      var data1 = {
        ...data,
        destination_id: this.props.destination_Id,
      }
      axios
        .put(Constant.getAPI() + '/cruise/update-cruise-destination', data1, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Destination Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/boatsmaster/${this.props.boatType}/${this.props.boatId}/destination-lists`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      this.setState({ isData: true })
      axios
        .post(Constant.getAPI() + '/cruise/add-cruise-destination', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Destination Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/boatsmaster/${this.props.boatType}/${this.props.boatId}/destination-lists`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  areDateRangesOverlapping = (ranges) => {
    // Convert to array of {from, to} with valid dates only
    const validRanges = ranges
      .map((r) => ({
        from: r.from_date,
        to: r.to_date,
      }))
      .filter((r) => r.from && r.to)

    for (let i = 0; i < validRanges.length; i++) {
      for (let j = i + 1; j < validRanges.length; j++) {
        // If ranges overlap
        if (validRanges[i].from <= validRanges[j].to && validRanges[j].from <= validRanges[i].to) {
          return true
        }
      }
    }
    return false
  }

  onSaveData = () => {
    // Validate that for all duration prices, to_date >= from_date
    const invalidDuration = this.state.cruise_destination_prices.some(
      (item) => item.from_date && item.to_date && item.to_date < item.from_date
    )
    if (invalidDuration) {
      Swal.fire({
        title: 'Validation Error',
        icon: 'error',
        text: 'Each To Date must be after or equal to From Date in Duration Prices.',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return
    }
    // Validate that no two duration price date ranges overlap
    if (this.areDateRangesOverlapping(this.state.cruise_destination_prices)) {
      Swal.fire({
        title: 'Validation Error',
        icon: 'error',
        text: 'Date ranges in Duration Prices must not overlap.',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return
    }

    this.setState({ isSaving: true })
    this.addDestination()
  }

  handleChangeHoliday = (index, event) => {
    let list = this.state.holiday_prices

    list[index][event.target.name] = event.target.value

    this.setState({
      holiday_prices: list,
    })
  }

  addHoliday = () => {
    let holiday_price_item = {
      date: new Date().toISOString().slice(0, 10),
      price: '0',
      b2b_price: '0',
    }

    this.setState({
      holiday_prices: [...this.state.holiday_prices, holiday_price_item],
    })
  }

  removeHoliday = (index) => {
    let list = this.state.holiday_prices

    list.splice(index, 1)

    this.setState({
      holiday_prices: list,
    })
  }

  handleAddressChange = (event) => {
    this.setState({ desti_id: event })
  }

  handleAddressClear = () => {
    this.setState({ desti_id: null })
  }

  render() {
    return (
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Address</label>
              <div className="col-sm-9">
                <Select
                  name="desti_id"
                  value={this.state.desti_id}
                  onChange={this.handleAddressChange}
                  options={this.state.GetAddress?.map((item) => ({ value: item.id, label: `${item.destination_address_en}/${item.destination_address_ar}` }))}
                  isMulti={false}
                  isSearchable={true}
                  isClearable
                  onClear={this.handleAddressClear}
                  placeholder="Select Options"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Book By</label>
              <div className="col-sm-9">
                <select
                  name="book_by"
                  className="form-control"
                  value={this.state.book_by}
                  onChange={this.handleChange}
                >
                  <option value="hours">HOURS</option>
                  <option value="day">DAYS</option>
                </select>
              </div>
            </div>
          </div>
          {this.state.book_by == 'hours' && (
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Destination Hours</label>
                <div className="col-sm-9">
                  <select
                    name="destination_min_hour"
                    className="form-control"
                    value={this.state.destination_min_hour}
                    onChange={this.handleChange}
                  >
                    <option>Select time(HH:MM)</option>
                    {getHourSlots().map(
                      (item) =>
                        item.value != '00:00:00' && (
                          <option
                            value={item.value}
                            key={item.value}
                          >
                            {item.label}
                          </option>
                        )
                    )}
                  </select>
                </div>
              </div>
            </div>
          )}
          {this.state.book_by == 'day' && (
            <>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Min Days</label>
                  <div className="col-sm-9">
                    <input
                      type="number"
                      className="form-control"
                      name="min_days"
                      placeholder="Days"
                      onChange={this.handleChange}
                      value={this.state.min_days}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Max Days</label>
                  <div className="col-sm-9">
                    <input
                      type="number"
                      className="form-control"
                      name="max_days"
                      placeholder="Days"
                      onChange={this.handleChange}
                      value={this.state.max_days}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Check In Time</label>
                  <div className="col-sm-9">
                    <select
                      name="check_in_time"
                      className="form-control"
                      value={this.state.check_in_time}
                      onChange={this.handleChange}
                    >
                      <option value="">Select time(HH:MM)</option>
                      {getHourSlots().map((item) => (
                        <option
                          value={item.value}
                          key={item.value}
                        >
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Check Out Time</label>
                  <div className="col-sm-9">
                    <select
                      name="check_out_time"
                      className="form-control"
                      value={this.state.check_out_time}
                      onChange={this.handleChange}
                    >
                      <option value="">Select time(HH:MM)</option>
                      {getHourSlots().map((item) => (
                        <option
                          value={item.value}
                          key={item.value}
                        >
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </>
          )}
          {this.state.book_by == 'day' && (
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Price Before Markup</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="price_before_markup"
                    id="price_before_markup"
                    placeholder="Price Before Markup"
                    value={this.state.price_before_markup}
                    min={0}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="col-md-12"></div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Same Price for all days</label>
              <div className="col-sm-9">
                <Toggle
                  className="ml-2 form-control"
                  name="same_price"
                  id="same_price"
                  onChange={this.handleChange}
                  checked={this.state.same_price}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Flash Offer</label>
              <div className="col-sm-9">
                <Toggle
                  className="ml-2 form-control"
                  name="is_flash_offer"
                  id="is_flash_offer"
                  onChange={this.handleChange}
                  checked={this.state.is_flash_offer}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Enable B2B Prices</label>
              <div className="col-sm-9">
                <Toggle
                  className="ml-2 form-control"
                  name="enable_b2b_prices"
                  id="enable_b2b_prices"
                  onChange={this.handleChange}
                  checked={this.state.enable_b2b_prices}
                />
              </div>
            </div>
          </div>
          {this.state.book_by == 'hours' && (
            <>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              >
                <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Normal Price</div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">{this.state.same_price ? 'Price' : 'Sunday Price'}</label>
                  <div className="col-sm-9">
                    <input
                      type="number"
                      className="form-control"
                      name="price"
                      placeholder="Price"
                      onChange={this.handleChange}
                      value={this.state.price}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">
                    {this.state.same_price ? 'Price Before Markup' : 'Sunday Price Before Markup'}
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="number"
                      className="form-control"
                      name="price_before_markup"
                      placeholder="Price Before Markup"
                      onChange={this.handleChange}
                      value={this.state.price_before_markup}
                      min={0}
                    />
                  </div>
                </div>
              </div>
              {!this.state.same_price && (
                <>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Monday Price</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="monday_price"
                          placeholder="Price"
                          onChange={this.handleChange}
                          value={this.state.monday_price}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Monday Price Before Markup</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="monday_price_before_markup"
                          placeholder="Price Before Markup"
                          onChange={this.handleChange}
                          value={this.state.monday_price_before_markup}
                          min={0}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Tuesday Price</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="tuesday_price"
                          placeholder="Price"
                          onChange={this.handleChange}
                          value={this.state.tuesday_price}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Tuesday Price Before Markup</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="tuesday_price_before_markup"
                          placeholder="Price Before Markup"
                          onChange={this.handleChange}
                          value={this.state.tuesday_price_before_markup}
                          min={0}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Wednesday Price</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="wednesday_price"
                          placeholder="Price"
                          onChange={this.handleChange}
                          value={this.state.wednesday_price}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Wednesday Price Before Markup</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="wednesday_price_before_markup"
                          placeholder="Price Before Markup"
                          onChange={this.handleChange}
                          value={this.state.wednesday_price_before_markup}
                          min={0}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Thursday Price</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="thursday_price"
                          placeholder="Price"
                          onChange={this.handleChange}
                          value={this.state.thursday_price}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Thursday Price Before Markup</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="thursday_price_before_markup"
                          placeholder="Price Before Markup"
                          onChange={this.handleChange}
                          value={this.state.thursday_price_before_markup}
                          min={0}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Friday Price</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="friday_price"
                          placeholder="Price"
                          onChange={this.handleChange}
                          value={this.state.friday_price}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Friday Price Before Markup</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="friday_price_before_markup"
                          placeholder="Price Before Markup"
                          onChange={this.handleChange}
                          value={this.state.friday_price_before_markup}
                          min={0}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Saturday Price</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="saturday_price"
                          placeholder="Price"
                          onChange={this.handleChange}
                          value={this.state.saturday_price}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Saturday Price Before Markup</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="saturday_price_before_markup"
                          placeholder="Price Before Markup"
                          onChange={this.handleChange}
                          value={this.state.saturday_price_before_markup}
                          min={0}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.state.enable_b2b_prices && (
                <>
                  <div
                    className="col-md-12"
                    style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                  >
                    <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>B2B Price</div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        {this.state.same_price ? 'Price' : 'Sunday Price'}
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          name="b2b_price"
                          placeholder="Price"
                          onChange={this.handleChange}
                          value={this.state.b2b_price}
                        />
                      </div>
                    </div>
                  </div>
                  {!this.state.same_price && (
                    <>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Monday Price</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="b2b_monday_price"
                              placeholder="Price"
                              onChange={this.handleChange}
                              value={this.state.b2b_monday_price}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Tuesday Price</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="b2b_tuesday_price"
                              placeholder="Price"
                              onChange={this.handleChange}
                              value={this.state.b2b_tuesday_price}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Wednesday Price</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="b2b_wednesday_price"
                              placeholder="Price"
                              onChange={this.handleChange}
                              value={this.state.b2b_wednesday_price}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Thursday Price</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="b2b_thursday_price"
                              placeholder="Price"
                              onChange={this.handleChange}
                              value={this.state.b2b_thursday_price}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Friday Price</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="b2b_friday_price"
                              placeholder="Price"
                              onChange={this.handleChange}
                              value={this.state.b2b_friday_price}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Saturday Price</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="b2b_saturday_price"
                              placeholder="Price"
                              onChange={this.handleChange}
                              value={this.state.b2b_saturday_price}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
          {this.state.book_by == 'day' && (
            <>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              >
                <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>
                  Duration Prices
                  <button
                    type="button"
                    className="btn btn-dark btn-round p-1 m-l-10"
                    onClick={this.addDurationPrices}
                  >
                    <i className="f-15 icofont icofont-plus m-0"></i>
                  </button>
                </div>
              </div>
              {this.state.cruise_destination_prices.map((item, index) => (
                <React.Fragment key={index}>
                  <div
                    className="col-12"
                    style={{
                      borderRadius: 10,
                      border: '1px solid #ddd',
                      background: '#eee',
                      marginBottom: 10,
                      padding: 16,
                    }}
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">From Date</label>
                          <div className="col-sm-9">
                            <input
                              type="date"
                              className="form-control"
                              name="from_date"
                              placeholder="From Date"
                              onChange={(e) => this.handleChangeDurationPrice(index, e)}
                              value={item.from_date}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">To Date</label>
                          <div className="col-sm-9">
                            <input
                              type="date"
                              className="form-control"
                              name="to_date"
                              placeholder="To Date"
                              onChange={(e) => this.handleChangeDurationPrice(index, e)}
                              value={item.to_date}
                              min={item.from_date || ''}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-12"
                        style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                      >
                        <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Normal Price</div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            {this.state.same_price ? 'Price' : 'Sunday Price'}
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="sunday_price"
                              placeholder="Price"
                              onChange={(e) => this.handleChangeDurationPrice(index, e)}
                              value={item.sunday_price}
                            />
                          </div>
                        </div>
                      </div>
                      {!this.state.same_price && (
                        <>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Monday Price</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="monday_price"
                                  placeholder="Price"
                                  onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                  value={item.monday_price}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Tuesday Price</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="tuesday_price"
                                  placeholder="Price"
                                  onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                  value={item.tuesday_price}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Wednesday Price</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="wednesday_price"
                                  placeholder="Price"
                                  onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                  value={item.wednesday_price}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Thursday Price</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="thursday_price"
                                  placeholder="Price"
                                  onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                  value={item.thursday_price}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Friday Price</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="friday_price"
                                  placeholder="Price"
                                  onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                  value={item.friday_price}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Saturday Price</label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="saturday_price"
                                  placeholder="Price"
                                  onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                  value={item.saturday_price}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {this.state.enable_b2b_prices && (
                        <>
                          <div
                            className="col-md-12"
                            style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                          >
                            <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>B2B Price</div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                {this.state.same_price ? 'Price' : 'Sunday Price'}
                              </label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="b2b_sunday_price"
                                  placeholder="Price"
                                  onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                  value={item.b2b_sunday_price}
                                />
                              </div>
                            </div>
                          </div>
                          {!this.state.same_price && (
                            <>
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Monday Price</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="b2b_monday_price"
                                      placeholder="Price"
                                      onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                      value={item.b2b_monday_price}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Tuesday Price</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="b2b_tuesday_price"
                                      placeholder="Price"
                                      onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                      value={item.b2b_tuesday_price}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Wednesday Price</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="b2b_wednesday_price"
                                      placeholder="Price"
                                      onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                      value={item.b2b_wednesday_price}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Thursday Price</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="b2b_thursday_price"
                                      placeholder="Price"
                                      onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                      value={item.b2b_thursday_price}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Friday Price</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="b2b_friday_price"
                                      placeholder="Price"
                                      onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                      value={item.b2b_friday_price}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Saturday Price</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="b2b_saturday_price"
                                      placeholder="Price"
                                      onChange={(e) => this.handleChangeDurationPrice(index, e)}
                                      value={item.b2b_saturday_price}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                    <div className="col-12 text-right">
                      <button
                        type="button"
                        className="btn btn-danger btn-round p-1 m-l-10"
                        onClick={() => this.removeDurationPrice(index)}
                      >
                        <i className="f-15 icofont icofont-minus m-0"></i> Remove
                      </button>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </>
          )}
          <div
            className="col-md-12"
            style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
          >
            <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>
              Holiday Prices
              <button
                type="button"
                className="btn btn-dark btn-round p-1 m-l-10"
                onClick={this.addHoliday}
              >
                <i className="f-15 icofont icofont-plus m-0"></i>
              </button>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              {this.state.holiday_prices.map((item, index) => (
                <>
                  <div className="col-1">
                    <div className="form-group row">
                      <label className="col-12 col-form-label">{index + 1}#</label>
                    </div>
                  </div>
                  <div className="col-10 row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Date</label>
                        <div className="col-sm-9">
                          <input
                            type="date"
                            className="form-control"
                            name="date"
                            id="date"
                            onChange={this.handleChangeHoliday.bind(this, index)}
                            value={item.date}
                            min={this.state?.startingDate}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Normal Price</label>
                        <div className="col-sm-9">
                          <input
                            type="number"
                            className="form-control"
                            name="price"
                            id="price"
                            placeholder={`Enter Value`}
                            onChange={this.handleChangeHoliday.bind(this, index)}
                            value={item.price}
                          />
                        </div>
                      </div>
                    </div>
                    {this.state.enable_b2b_prices && (
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">B2B Price</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="b2b_price"
                              id="b2b_price"
                              placeholder={`Enter Value`}
                              onChange={this.handleChangeHoliday.bind(this, index)}
                              value={item.b2b_price}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-1">
                    <button
                      type="button"
                      className="btn btn-danger btn-round p-1 m-l-10"
                      onClick={() => {
                        this.removeHoliday(index)
                      }}
                    >
                      <i className="f-15 icofont icofont-minus m-0"></i>
                    </button>
                  </div>
                </>
              ))}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="row">
            <div className="text-right col-6 offset-6">
              <Link
                to={`/boatsmaster/${this.props.boatType}/${this.props.boatId}/destination-lists`}
                className="btn btn-outline-secondary m-2 "
              >
                <i className="icofont icofont-rounded-double-left"></i>
                Back
              </Link>
              {this.state.isData ? (
                <button
                  className="btn btn-grd-disabled mr-2"
                  disabled
                >
                  Saving...!
                </button>
              ) : (
                <button
                  onClick={this.onSaveData}
                  className="btn hor-grd btn-grd-inverse offset-1"
                >
                  <i className="ti-save"></i>Save
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DestinationAdd
